/* ============================================================
   KORENA — theme interactivity (Dossier).
   Consolidated from the static build: masthead, sticky nav,
   mobile nav, mobile sliders, accordions, ingredient modal,
   bundle selection, PDP gallery. All guarded — each page runs
   only what it contains. Cart is Shopify-native (forms post to
   /cart/add); no localStorage cart here.
   ============================================================ */
(function () {
  function ready(fn){ if(document.readyState!=="loading"){fn();} else {document.addEventListener("DOMContentLoaded",fn);} }

  ready(function () {
    // ---- Masthead rotation ----
    (function () {
      const e = document.getElementById("mast"); if (!e) return;
      const def = ["Free shipping over $35", "Our team answers every email", "8 actives, one mask"];
      const attr = (e.getAttribute("data-mast-messages") || "").split("\n").map(function (s) { return s.trim(); }).filter(Boolean);
      const m = attr.length ? attr : def;
      e.textContent = m[0];
      const animate = document.body.getAttribute("data-anim-masthead") !== "false";
      if (m.length < 2 || !animate) return;
      let i = 0;
      setInterval(() => { e.style.opacity = 0; setTimeout(() => { i = (i + 1) % m.length; e.textContent = m[i]; e.style.opacity = 1; }, 380); }, 4200);
    })();

    // ---- Masthead countdown (only renders when a genuine deadline is set in theme settings) ----
    (function () {
      const bar = document.querySelector(".masthead[data-mast-deadline]"); if (!bar) return;
      const box = bar.querySelector("[data-mast-timer]"); if (!box) return;
      let end = Date.parse(bar.getAttribute("data-mast-deadline")); if (isNaN(end)) return;
      const repeatDaily = bar.getAttribute("data-mast-repeat-daily") === "true";
      const q = (k) => box.querySelector('[data-t="' + k + '"]');
      const el = { d: q("d"), h: q("h"), m: q("m"), s: q("s") };
      const pad = (n) => String(n).padStart(2, "0");
      function tick () {
        let left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0 && repeatDaily) {
          do { end += 86400000; } while (end <= Date.now());
          left = Math.floor((end - Date.now()) / 1000);
        }
        if (left <= 0) { box.hidden = true; clearInterval(iv); return; }
        el.d.textContent = pad(Math.floor(left / 86400)); left %= 86400;
        el.h.textContent = pad(Math.floor(left / 3600)); left %= 3600;
        el.m.textContent = pad(Math.floor(left / 60));
        el.s.textContent = pad(left % 60);
        box.hidden = false;
      }
      const iv = setInterval(tick, 1000); tick();
    })();

    // ---- Sticky nav shadow ----
    (function () {
      const nav = document.getElementById("nav"); if (!nav) return;
      const f = () => nav.dataset.stuck = (window.scrollY > 40); window.addEventListener("scroll", f, { passive: true }); f();
    })();

    // ---- Accordions (generic: .k-acc__item with .k-acc__head) ----
    document.querySelectorAll(".k-acc").forEach(function (acc) {
      acc.querySelectorAll(".k-acc__item").forEach(function (item) {
        const head = item.querySelector(".k-acc__head"); if (!head) return;
        head.addEventListener("click", function () {
          const open = item.dataset.open === "true";
          acc.querySelectorAll(".k-acc__item").forEach(function (x) { x.dataset.open = "false"; const h = x.querySelector(".k-acc__head"); if (h) h.setAttribute("aria-expanded", "false"); });
          if (!open) { item.dataset.open = "true"; head.setAttribute("aria-expanded", "true"); }
        });
      });
    });

    // ---- Bundle / variant radio selection (homepage). PDP opts out via
    //      data-managed and runs its own pricing script (one-time/subscribe). ----
    document.querySelectorAll(".k-bundles:not([data-managed])").forEach(function (host) {
      const rows = host.querySelectorAll(".k-bundle");
      function sync(sel) {
        rows.forEach(function (r) {
          const input = r.querySelector("input[type=radio]");
          const on = input && input.checked;
          r.dataset.selected = on ? "true" : "false";
          if (on) {
            const price = r.getAttribute("data-price") || "";
            document.querySelectorAll("[data-add-price]").forEach(function (el) { if (price) el.textContent = price; });
            document.querySelectorAll("[data-price-line]").forEach(function (el) { if (price) el.textContent = price; });
          }
        });
      }
      rows.forEach(function (r) {
        const input = r.querySelector("input[type=radio]");
        r.addEventListener("click", function () { if (input) { input.checked = true; sync(); } });
        r.addEventListener("keydown", function (e) { if ((e.key === "Enter" || e.key === " ") && input) { e.preventDefault(); input.checked = true; sync(); } });
        if (input) input.addEventListener("change", sync);
      });
      sync();
    });

    // ---- PDP / catalog gallery: thumb click swaps main image ----
    document.querySelectorAll("[data-gallery]").forEach(function (g) {
      const main = g.querySelector("[data-gallery-main]");
      g.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
        t.addEventListener("click", function () {
          g.querySelectorAll("[data-gallery-thumb]").forEach(function (x) { x.dataset.active = "false"; });
          t.dataset.active = "true";
          const src = t.getAttribute("data-src"); if (main && src) main.src = src;
        });
      });
    });


    // ---- Actives scatter hover (homepage + PDP) ----
    (function () {
      const list = document.getElementById("exList");
      const scatter = document.getElementById("exScatter");
      if (!list || !scatter) return;
      const rows = Array.prototype.slice.call(list.querySelectorAll(".ex-item"));
      const imgs = Array.prototype.slice.call(scatter.querySelectorAll(".ex-img"));
      function activate(i, moveImg) {
        if (rows[i]) rows[i].classList.add("is-active");
        const f = imgs[i]; if (!f) return; f.classList.add("is-active");
        const base = parseFloat(f.dataset.rot || "0");
        f.style.transform = moveImg ? "translate(-10px,-14px) rotate(" + (base * 0.35) + "deg) scale(1.05)" : "rotate(" + (base * 0.5) + "deg) scale(1.04)";
      }
      function deactivate(i) { if (rows[i]) rows[i].classList.remove("is-active"); const f = imgs[i]; if (!f) return; f.classList.remove("is-active"); f.style.transform = ""; }
      imgs.forEach(function (f, i) { f.addEventListener("mouseenter", function () { activate(i, false); }); f.addEventListener("mouseleave", function () { deactivate(i); }); });
      rows.forEach(function (r, i) { r.addEventListener("mouseenter", function () { activate(i, true); }); r.addEventListener("mouseleave", function () { deactivate(i); }); });
    })();

    // ---- Seamless marquee (homepage) ----
    (function () {
      const track = document.querySelector(".marquee__track");
      const marquee = document.querySelector(".marquee");
      if (!track || !marquee) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const base = track.querySelector(".marquee__group"); if (!base) return;
      track.style.animation = "none";
      const SPEED = 70; let anim = null;
      function setup() {
        const groupWidth = base.getBoundingClientRect().width; if (!groupWidth) return;
        let guard = 0;
        while (track.scrollWidth < marquee.offsetWidth + groupWidth && guard < 16) { const c = base.cloneNode(true); c.setAttribute("aria-hidden", "true"); track.appendChild(c); guard++; }
        if (anim) anim.cancel();
        anim = track.animate([{ transform: "translateX(0)" }, { transform: "translateX(-" + groupWidth + "px)" }], { duration: (groupWidth / SPEED) * 1000, iterations: Infinity, easing: "linear" });
      }
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setup); } else { setup(); }
      let rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(setup, 200); });
    })();

    // ---- Signup note placeholder (no-op; Shopify {% form %} handles submit) ----
  });

  /* ===== Mobile nav (hamburger + slide-in menu) ===== */
  (function () {
    function injectStyles() {
      if (document.getElementById("korena-mnav-styles")) return;
      const css = `
.nav__burger{display:none;}
@media (max-width:920px){.nav__burger{display:inline-flex;align-items:center;justify-content:center;width:42px;height:42px;margin-left:-9px;border:0;background:transparent;color:var(--text-strong);cursor:pointer;-webkit-tap-highlight-color:transparent;flex:none;order:-1;}}
.mnav-scrim{position:fixed;inset:0;background:rgba(28,26,25,.42);backdrop-filter:blur(2px);opacity:0;pointer-events:none;transition:opacity .3s var(--ease-out);z-index:120;}
.mnav-scrim[data-open="true"]{opacity:1;pointer-events:auto;}
.mnav{position:fixed;top:0;left:0;bottom:0;width:min(330px,86vw);background:var(--korena-paper-doc);z-index:121;display:flex;flex-direction:column;transform:translateX(-100%);transition:transform .34s var(--ease-out);box-shadow:var(--shadow-pop);}
.mnav[data-open="true"]{transform:translateX(0);}
.mnav__head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid var(--border-hairline);}
.mnav__title{font-family:var(--font-mono);font-size:11px;letter-spacing:var(--ls-mono);text-transform:uppercase;color:var(--text-muted);}
.mnav__links{display:flex;flex-direction:column;overflow-y:auto;}
.mnav__links a{display:block;padding:17px 22px;font-family:var(--font-display);font-size:23px;letter-spacing:-.01em;color:var(--text-strong);text-decoration:none;border-bottom:1px solid var(--border-hairline);}
.mnav__links a[aria-current="page"]{color:var(--accent);}
.mnav__links a.mnav__sub{font-family:var(--font-mono);font-size:13px;letter-spacing:var(--ls-mono);text-transform:uppercase;color:var(--text-muted);padding:14px 22px;}
.mnav__foot{margin-top:auto;padding:18px 22px;border-top:1px solid var(--border-hairline);font-family:var(--font-mono);font-size:11px;letter-spacing:var(--ls-mono);text-transform:uppercase;color:var(--text-muted);}`;
      const tag = document.createElement("style"); tag.id = "korena-mnav-styles"; tag.textContent = css; document.head.appendChild(tag);
    }
    let menu = null;
    function buildMenu(nav) {
      if (menu) return menu;
      let linksHTML = "";
      nav.querySelectorAll(".nav__links a").forEach(function (a) { linksHTML += '<a href="' + a.getAttribute("href") + '"' + (a.getAttribute("aria-current") ? ' aria-current="page"' : "") + ">" + a.textContent.trim() + "</a>"; });
      if (!linksHTML) return null;
      const extra = [["Contact", "/pages/contact"], ["About", "/pages/about"], ["Shipping & returns", "/pages/shipping-returns"]];
      let subHTML = ""; extra.forEach(function (e) { subHTML += '<a class="mnav__sub" href="' + e[1] + '">' + e[0] + "</a>"; });
      const scrim = document.createElement("div"); scrim.className = "mnav-scrim"; scrim.setAttribute("data-open", "false");
      const panel = document.createElement("aside"); panel.className = "mnav"; panel.setAttribute("data-open", "false"); panel.setAttribute("aria-label", "Menu");
      panel.innerHTML = '<div class="mnav__head"><span class="mnav__title">Korena® · Menu</span><button class="k-iconbtn" aria-label="Close menu" data-mnav-close><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div><nav class="mnav__links">' + linksHTML + subHTML + '</nav><div class="mnav__foot">Australian-owned · K-beauty-inspired</div>';
      document.body.appendChild(scrim); document.body.appendChild(panel);
      const open = function () { scrim.dataset.open = "true"; panel.dataset.open = "true"; document.body.style.overflow = "hidden"; };
      const close = function () { scrim.dataset.open = "false"; panel.dataset.open = "false"; document.body.style.overflow = ""; };
      scrim.addEventListener("click", close);
      panel.querySelector("[data-mnav-close]").addEventListener("click", close);
      panel.querySelectorAll(".mnav__links a").forEach(function (a) { a.addEventListener("click", close); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
      menu = { open: open, close: close }; return menu;
    }
    function ensure() {
      const nav = document.querySelector(".nav"); if (!nav) return;
      const utils = nav.querySelector(".nav__utils"); if (utils) { const s = utils.querySelector('[aria-label="Search"]'); if (s) s.remove(); }
      if (!nav.querySelector(".nav__burger")) {
        const m = buildMenu(nav); if (!m) return;
        const burger = document.createElement("button"); burger.type = "button"; burger.className = "nav__burger"; burger.setAttribute("aria-label", "Open menu");
        burger.innerHTML = '<svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"></path></svg>';
        burger.addEventListener("click", m.open); nav.insertBefore(burger, nav.firstChild);
      }
    }
    injectStyles();
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ensure); else ensure();
    window.addEventListener("load", ensure);
  })();

  /* ===== Mobile sliders (arrows + dots under horizontal scrollers) ===== */
  (function () {
    function injectStyles() {
      if (document.getElementById("korena-sldr-styles")) return;
      const css = `
.sldr-ctrl{display:none;}
@media (max-width:920px){.sldr-ctrl{display:flex;align-items:center;justify-content:center;gap:16px;margin-top:16px;padding:0 20px;}
.sldr-arrow{flex:none;width:38px;height:38px;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:rgba(28,26,25,0.05);color:rgba(28,26,25,0.38);cursor:pointer;}
.sldr-arrow:disabled{opacity:0.25;}
.sldr-dots{display:flex;align-items:center;gap:8px;}
.sldr-dot{width:7px;height:7px;border-radius:50%;background:var(--korena-ink,#1C1A19);opacity:0.22;transition:transform .25s cubic-bezier(0.22,1,0.36,1),opacity .25s;cursor:pointer;}
.sldr-dot[data-active="true"]{opacity:1;transform:scale(1.85);}}`;
      const tag = document.createElement("style"); tag.id = "korena-sldr-styles"; tag.textContent = css; document.head.appendChild(tag);
    }
    function build(scroller) {
      if (!scroller || scroller.dataset.sldrInit) return;
      const cards = Array.prototype.slice.call(scroller.children); const n = cards.length; if (n < 2) return;
      scroller.dataset.sldrInit = "1";
      const ctrl = document.createElement("div"); ctrl.className = "sldr-ctrl";
      const prev = document.createElement("button"); prev.type = "button"; prev.className = "sldr-arrow"; prev.setAttribute("aria-label", "Scroll left");
      prev.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 6l-6 6 6 6"></path></svg>';
      const dotsWrap = document.createElement("div"); dotsWrap.className = "sldr-dots";
      const dots = cards.map(function (_, i) { const d = document.createElement("span"); d.className = "sldr-dot"; dotsWrap.appendChild(d); return d; });
      const next = document.createElement("button"); next.type = "button"; next.className = "sldr-arrow"; next.setAttribute("aria-label", "Scroll right");
      next.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"></path></svg>';
      ctrl.appendChild(prev); ctrl.appendChild(dotsWrap); ctrl.appendChild(next);
      scroller.parentNode.insertBefore(ctrl, scroller.nextSibling);
      function activeIndex() { const s = scroller.getBoundingClientRect(); const c = s.left + s.width / 2; let b = 0, bd = Infinity; for (let i = 0; i < n; i++) { const r = cards[i].getBoundingClientRect(); const dd = Math.abs((r.left + r.width / 2) - c); if (dd < bd) { bd = dd; b = i; } } return b; }
      function update() { const idx = activeIndex(); for (let i = 0; i < n; i++) dots[i].dataset.active = (i === idx); prev.disabled = scroller.scrollLeft <= 2; next.disabled = scroller.scrollLeft >= (scroller.scrollWidth - scroller.clientWidth - 2); }
      function to(i) { i = Math.max(0, Math.min(n - 1, i)); const c = cards[i]; const s = scroller.getBoundingClientRect(); const r = c.getBoundingClientRect(); scroller.scrollTo({ left: scroller.scrollLeft + (r.left + r.width / 2) - (s.left + s.width / 2), behavior: "smooth" }); }
      prev.addEventListener("click", function () { to(activeIndex() - 1); });
      next.addEventListener("click", function () { to(activeIndex() + 1); });
      dots.forEach(function (d, i) { d.addEventListener("click", function () { to(i); }); });
      scroller.addEventListener("scroll", function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener("resize", update); update();
    }
    function initAll() { [".inggrid", ".shop__thumbs", ".gallery__thumbs"].forEach(function (sel) { document.querySelectorAll(sel).forEach(build); }); }
    injectStyles();
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll); else initAll();
  })();
})();
